import { Product } from '@news-mono/web-common'

export const getNielsenProgramName = (product: Product) => {
    switch (product) {
        case Product.SevenNews:
            return '7NEWS Videos'
        case Product.PerthNow:
            return 'PerthNow Videos'
        case Product.TheWest:
            return 'The West Videos'
    }
}

// Update poster frame size to match hero image
// we will do futher work in the future for responsive poster frames.
export const getImageWidth = (product: Product) => {
    switch (product) {
        case Product.PerthNow:
            return 1024 //668
        case Product.TheWest:
            return 1024 //810
        case Product.SevenNews:
            return 1024 //650
    }
}
